/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=27a9824c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=27a9824c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a9824c"],['__file',"library/layouts/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27a9824c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27a9824c', __exports__)) {
    api.reload('27a9824c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=27a9824c&scoped=true&ts=true", () => {
    api.rerender('27a9824c', render)
  })

}


export default __exports__